import { render, staticRenderFns } from "./Trailer.vue?vue&type=template&id=575b29dc&"
import script from "./Trailer.vue?vue&type=script&lang=js&"
export * from "./Trailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports